import { authHeader,check419 } from "../helpers";

export const setService = {
    getSetsList,
    getKitsList,
    getProductsList,
    addSet,
    getById,
    updateSet,
    updateMissingAndQuarantineStock,
    getMissingStockHistory,
    getQuarantineHistory,
    getSetsUsingKitIdForBookingFilter,
    delete: _delete,
    updateSetStatus,
    resetCounter,
    getSetsUsingBookingId,
    getSetsExport,
    getSetsForUtilisationReportDropdown,
    
};

function getSetsList(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search)
    };

    return fetch(process.env.REACT_APP_APIURL+"sets/getSets", requestOptions).then(handleResponse)
        .then( setsList => {
            return setsList;
        });
}

function resetCounter(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search)
    };

    return fetch(process.env.REACT_APP_APIURL+"sets/resettotalcounter", requestOptions).then(handleResponse)
        .then( setsList => {
            return setsList;
        });
}

function getMissingStockHistory(setInfo) {
    console.log("object", setInfo);
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(setInfo)
    };

    return fetch(process.env.REACT_APP_APIURL+"sets/get-missing-stock-history", requestOptions).then(handleResponse);
}

function getQuarantineHistory(setInfo) {
    console.log("object", setInfo);
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(setInfo)
    };

    return fetch(process.env.REACT_APP_APIURL+"sets/get-quarantine-history", requestOptions).then(handleResponse);
}

function getKitsList(searchString) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(searchString)
    };

    return fetch(process.env.REACT_APP_APIURL+"kits/searchKits", requestOptions).then(handleResponse)
        .then(kitsList => {
            return kitsList;
        });
}

function updateSetStatus(kitInfo) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(kitInfo),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "sets/update-status",
        requestOptions
    ).then(handleResponse);
}

function getProductsList(searchString) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(searchString)
    };

    return fetch(process.env.REACT_APP_APIURL+"products/searchProducts", requestOptions).then(handleResponse)
        .then(productsList => {
            return productsList;
        });
}

function getById(id) {
    const requestOptions = {
        method: "GET",
        headers: authHeader()
    };

    return fetch(process.env.REACT_APP_APIURL+`sets/getSet/${id}`, requestOptions).then(handleResponse);
}

function addSet(setInfo) {
    const requestOptions = {
        method: "POST",
        headers: {...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(setInfo)
    };

    return fetch(process.env.REACT_APP_APIURL+"sets/saveSets", requestOptions).then(handleResponse);
}

function updateSet(setInfo) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(setInfo)
    };

    return fetch(process.env.REACT_APP_APIURL+"sets/updateSets", requestOptions).then(handleResponse);
}

function updateMissingAndQuarantineStock(setInfo) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(setInfo)
    };

    return fetch(process.env.REACT_APP_APIURL+"sets/updateMissingAndQuarantineStock", requestOptions).then(handleResponse);
}

function getSetsUsingKitIdForBookingFilter(kitInfo) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(kitInfo)
    };

    return fetch(process.env.REACT_APP_APIURL+"sets/getSetsUsingKitIdForBookingFilter", requestOptions).then(handleResponse);
}

// // prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(id)
    };

    return fetch(process.env.REACT_APP_APIURL+"sets/deleteSets", requestOptions).then(handleResponse);
}

// // prefixed function name with underscore because delete is a reserved word in javascript
function getSetsUsingBookingId(id) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(id)
    };

    return fetch(process.env.REACT_APP_APIURL+"sets/get-sets-booking-id", requestOptions).then(handleResponse);
}

function getSetsExport(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search)
    };

    return fetch(process.env.REACT_APP_APIURL+"sets/getSetsExport", requestOptions).then(handleResponse)
        .then( setsList => {
            return setsList;
        });
}


function getSetsForUtilisationReportDropdown(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search)
    };

    return fetch(process.env.REACT_APP_APIURL+"sets/getSetsForUtilisationReportDropdown", requestOptions).then(handleResponse)
        .then( setsList => {
            return setsList;
        });
}


function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        //const data = text;
        if (!response.ok) {
            if (response.status === 400) {
                // auto logout if 401 response returned from api
                // logout();
                // location.reload(true);
                const error = (data && data.data.errors) || response.statusText;
                return Promise.reject(error);
            } else if(response.status === 419){
                check419();
            }

            // const error = (data && data.message) || response.statusText;
            // return Promise.reject(error);
        }

        return data;
    });
}